module.exports = __webpack_public_path__ + "img/vertical_6_7_0.ba6d8816.png";